import { styled } from '@mui/material';
import { Spinner } from '@kc-console/common-ui';

/**
 * Dynamic Panel 구현을 불러오는 동안 패널 영역에 표시하는 공통 로딩 화면입니다.
 */
export default function PanelLoadingFallback() {
  return (
    <PanelLoadingFallbackRoot>
      <Spinner size="md" />
    </PanelLoadingFallbackRoot>
  );
}

const PanelLoadingFallbackRoot = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
